import { generateRootObjectSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";

export const specification = new BaseAtomSpec("Freshworks Widget", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
}));
